import HeroCarousel from "./components/HeroCarousel";
import CategoryEntry from "./components/CategoryEntry";
import LatestSection from "./components/LatestSection";
import RankingSection from "./components/RankingSection";
import SiteIntro from "./components/SiteIntro";
import { usePageMeta } from "@/hooks/usePageMeta";
import { getMediaById } from "@/lib/media";
import { movies } from "@/mocks/movies";
import { tvShows } from "@/mocks/tvShows";

const featuredIds = ["m1", "m4", "m12", "t1", "t4"];

export default function Home() {
  usePageMeta({
    title: "免费观看大片在线观看 - 热门电影资源电视大全",
    description:
      "免费观看大片在线观看网站为您提供最新热门电影、电视剧资源，覆盖多类型影片，满足用户免费在线观看需求，轻松查找大片信息。",
    keywords:
      "免费观看大片在线观看,在线电影,热门电影,电影资源,高清大片,影视大全,电影下载",
  });

  const featured = featuredIds
    .map((id) => getMediaById(id))
    .filter((item): item is NonNullable<typeof item> => Boolean(item));

  return (
    <>
      <h1 className="sr-only">免费观看大片在线观看 - 热门电影电视剧在线观看平台</h1>
      <HeroCarousel items={featured} />
      <CategoryEntry movieCount={movies.length} tvCount={tvShows.length} />
      <LatestSection />
      <RankingSection />
      <SiteIntro />
    </>
  );
}